import type { SignupFlow } from 'corgi-types';
import { QueryParam } from 'corgi-types';
import type { UserType } from 'graphql-ts-types';

import { useLocalization } from '../providers/LocaleProvider';
import { getUserFlowQueryParam } from '../utils/signup';

interface UseRegistrationURLParams {
  userFlow: SignupFlow;
  referredBy?: string;
  userType?: UserType;
}

export const useRegistrationURL = ({
  userFlow,
  referredBy,
  userType,
}: UseRegistrationURLParams) => {
  const { prefix } = useLocalization();

  let registrationUrl = `/registration${getUserFlowQueryParam(userFlow)}`;

  if (referredBy) {
    registrationUrl += `&code=${referredBy}`;
  }

  if (userType) {
    registrationUrl += `&${QueryParam.UserType}=${userType}`;
  }

  return prefix(registrationUrl);
};
